import { initMonitoringStepOne } from '../../app/initMonitoringStepOne';

/*
 * Initialize error tracking & session screen recording as early as possible
 */
initMonitoringStepOne();

/**
 * Dynamic import for code splitting: https://webpack.js.org/guides/code-splitting/
 */
if (!window.MATERIO_UNSUPPORTED_BROWSER_DETECTED) {
  import('./login.jsx').then((module) => module.default());
}
